import { Helmet } from 'react-helmet-async'

import { useApiHubPlan } from '~/hooks/useApiHubPlan'
import { getPageAppTitle } from '~/utils/shared/routing'

interface ConsumerHeadTagsProps {
  favicon?: string;
  previewName?: string;
  googleTagManager?: string;
}

const ConsumerHeadTags = ({ favicon, previewName, googleTagManager }: ConsumerHeadTagsProps) => {
  const { platformManaged } = useApiHubPlan()

  const fav = favicon || (platformManaged ? '/favicon_pm.ico?v=1' : '/favicon.ico?v=2')

  return (
    <Helmet>
      {previewName && <title>{previewName} | Preview | {getPageAppTitle(platformManaged)}</title>}
      <link type="image/x-icon" rel="icon" href={fav} />
      {googleTagManager && <script
        type="text/javascript"
      >{`(function(w,d,s,l,i){w[l] = w[l] || []; w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${googleTagManager}');`
        }</script>}
    </Helmet>
  )
}

export default ConsumerHeadTags